import { UntypedFormControl } from "@angular/forms";

export function disableMaterial(element, ngControl: UntypedFormControl) {
  ngControl.disable();
}
